import {Box, IconButton, Typography, useColorScheme, useTheme} from "@mui/material";
import {getAcceptedImageMimeTypes} from "@/constant/acceptedFiles";
import {useRef, useState} from "react";
import {EditOutlined} from "@mui/icons-material";
import {toast} from "react-toastify";

export type SquareThumbInputProps = {
    onChanged: (file:File|Blob) => void,
    required?: boolean,
    label?: string,
    description?: string,
    imgValue?: string;
}
const SquareThumbInput = ({onChanged, description, label, required, imgValue}:SquareThumbInputProps) => {
    const theme = useTheme();
    const {mode} = useColorScheme();

    const inputRef = useRef<HTMLInputElement>(null);

    const [previewPath, setPreviewPath] = useState('');
    const [files, setFiles] = useState<FileList | null>();

    return (
        <Box sx={{mb: 2}}>
            {!!label ? <Typography variant={'body2'} component={'label'} gutterBottom sx={{display: 'block'}}>
                {label} {required ? '*' : ''}
            </Typography> : ''}
            <Box sx={{
                display: 'flex',
                alignItems: 'end',
            }}>
                <Box sx={{
                    width: 122,
                    aspectRatio: '1',
                    backgroundColor: mode === 'dark' ? '#686767' : '#c1c1c1',
                    borderRadius: 'var(--v-shape-borderRadius)',
                    overflow: 'hidden',
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: !previewPath ? 'pointer' : undefined,
                }} onClick={() => {
                    if (inputRef.current) inputRef.current.click();
                }}>
                    {!!previewPath && (
                        <img src={previewPath} alt={''} style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                        }}/>
                    )}
                    {!previewPath && imgValue && (
                        <img
                            src={imgValue}
                            alt={''}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                objectPosition: 'center',
                            }}
                            onError={e => {
                                e.currentTarget.src = ''
                            }}
                        />
                    )}

                    <IconButton sx={{
                        position: 'absolute',
                        zIndex: 10,
                        backgroundColor: 'rgba(255,255,255,0.5)',
                    }}>
                        <EditOutlined />
                    </IconButton>

                    <input ref={inputRef} type={'file'}
                           accept={getAcceptedImageMimeTypes('string') as string}
                           style={{
                               display: 'none',
                           }}
                           onChange={(ev) => {
                               const target = ev.target;
                               const files = target.files;


                               if (!files || !files.length) return false;
                               const path = !!files ? URL.createObjectURL(files[0]) : '';

                               const accepted = getAcceptedImageMimeTypes('string');
                               if (!accepted.includes(files[0].type)) {
                                   toast.error(`허용되지 않는 파일형식입니다. 허용된 형식(${getAcceptedImageMimeTypes('string')})의 이미지 파일을 선택해주세요.`)
                                   return false;
                               }

                               setPreviewPath(path);
                               setFiles(files);

                               if (!!onChanged && !!files) {
                                   onChanged(files[0])
                               }
                           }}/>
                </Box>

                <Box sx={{
                    flexGrow: 1,
                    ml: 1,
                }}>
                    <Typography variant={'caption'} sx={{whiteSpace: 'pre-wrap'}}>{description}</Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default SquareThumbInput;